import EVENTS from '@/utils/Constants/Events';

export default (response, uuidToken) => {
  DLG.EVE.emit(EVENTS.SPLASH.LOADER.CLOSE, uuidToken);
  return response;
};
